import React from 'react';
import styles from './BackDrop.module.scss';

export default function BackDrop() {
  return <div className={styles.backDropWrapper}></div>;
}
